import { Box, Image } from '@chakra-ui/react';

function Logo({ src, alt }) {
  return (
    <Box mb="36px">
      <Image src={src} alt={alt} htmlHeight={24} htmlWidth={170} />
    </Box>
  );
}

export { Logo };
